import axios from 'axios';
import { API_BASE_URL } from '../../../../lib/constants';

export const fetchPatientData = async (uhidNo) => {
  const response = await axios.get(`${API_BASE_URL}/get_patient/${uhidNo}`);
  return response.data;
};

export const fetchPostOpInstructions = async (uhidNo) => {
  const response = await axios.get(`${API_BASE_URL}/get_post_op_instruction/${uhidNo}`);
  return response.data;
};

export const fetchNextIpNo = async () => {
  const response = await axios.get(`${API_BASE_URL}/postop_instruct_next_ip`);
  return response.data;
};

export const savePostOpInstructions = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/post_op_instructions`, data);
  return response.data;
};

export const updatePostOpInstructions = async (uhidNo, data) => {
  const response = await axios.put(`${API_BASE_URL}/update_post_op_instruction/${uhidNo}`, data);
  return response.data;
};

export const generateShareToken = async (uhidNo) => {
  const response = await axios.post(`${API_BASE_URL}/generate_for_post_op_instruct_share_token/${uhidNo}`);
  return response.data;
};
